import { Button, Modal, TextField } from '@superops/ui-design-system';
import React, { useContext, useState } from 'react';
import {
  getTranslatedText,
  TEXT_LENGTH,
  Logo as ModuleLogo
} from '@nile/components';
import envConfig from '@nile/home/src/Config/env';
import { FormattedMessage, useIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { cloneDeep } from 'lodash';
import DataReportsContext from '@nile/reports/src/modules/DataReports/contexts';
import { HeaderContainer } from '@nile/reports/src/modules/charts/components/subpages/ChartHeader/styles';
import { SVGIcon } from '@superops/super-icons';

const DataReportHeader = (props) => {
  const intl = useIntl();
  const dataContext = useContext(DataReportsContext);

  const [closeConfirmation, setCloseConfirmation] = useState(false);

  const { errors, submitActionLoading, handleSave, closeModal } = props;

  const handleChange = (prop, newValue) => {
    const updatedData = cloneDeep(dataContext.headerValue);
    updatedData[prop] = newValue;
    dataContext.updateHeaderValue(updatedData);
  };

  const closeConfirmationModal = () => {
    if (!dataContext.isUpdated()) {
      setCloseConfirmation(true);
      return;
    }
    closeModal();
  };

  const onDiscard = () => {
    closeModal();
  };

  return (
    <HeaderContainer className="fx actr fx-sb bg-white p25 position-relative brTransparent">
      <div className="flex f11 actr">
        <ModuleLogo
          className="mr10"
          url={`${envConfig.imageRoot}svg/Charts.svg`}
        />
        <div className="fx fcol f11">
          <TextField
            placeholder={getTranslatedText(
              intl,
              'reports.chart.title.placeholder'
            )}
            value={dataContext?.headerValue?.name}
            onChange={(val) => handleChange('name', val)}
            error={errors?.name?.[0]}
            autoFocus
            noborder
            bgTransparent
            fontSize="fontLarge"
            maxLength={TEXT_LENGTH.size_5}
          />
          <div className="description">
            <TextField
              placeholder={getTranslatedText(
                intl,
                'reports.chart.description.placeholder'
              )}
              value={dataContext?.headerValue?.description}
              onChange={(val) => handleChange('description', val)}
              error={errors?.description?.[0]}
              noborder
              bgTransparent
              maxLength={TEXT_LENGTH.size_10}
            />
          </div>
        </div>
      </div>
      <div className="flex f11 jend g10">
        <div className="fx actr">
          <Modal
            activator={
              <Button onClick={() => closeConfirmationModal()} plain monochrome>
                <FormattedMessage id="common.close" />
              </Button>
            }
            open={closeConfirmation}
            onClose={() => setCloseConfirmation(false)}
            variant="confirmation"
            title={
              <FormattedMessage id="reports.chart.create.modal.discardChanges" />
            }
            primaryAction={{
              content: (
                <div className="flex actr">
                  <FormattedMessage id="common.button.discardChanges" />
                </div>
              ),
              onAction: onDiscard
            }}
            secondaryActions={[
              {
                content: <FormattedMessage id="common.cancel" />,
                onAction: () => setCloseConfirmation(false)
              }
            ]}
          />
        </div>
        <Button
          primary
          onClick={handleSave}
          loading={submitActionLoading}
          id={props.id}
          icon={<SVGIcon name="Save" color="#ffffff" />}
        >
          <FormattedMessage id="common.save" />
        </Button>
      </div>
    </HeaderContainer>
  );
};

export default withRouter(DataReportHeader);
